(function() {
    const formWrap = document.getElementById( 'fs-form-wrap' );

    [].slice.call( document.querySelectorAll( 'select.cs-select' ) ).forEach( (el) => {    
        new SelectFx( el, {
            stickyPlaceholder: false,
            onChange(val){
                document.querySelector('span.cs-placeholder').style.backgroundColor = val;
            },
        });
    } );

    new FForm( formWrap, {
        // show progress bar
        ctrlProgress : true,

        // show navigation dots
        ctrlNavDots : true,

        // show [current field]/[total fields] status
        ctrlNavPosition : true,

        // reached the review and submit step
        onReview() { return false; },
    } );
})();